import React, { useEffect, useState } from "react";
import { Footer, Navbar } from "../components";
import api from "../utils/base_url";
import '../styles/index.css';
import { useNavigate } from "react-router-dom";

const AboutPage = () => {
  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();
  const handleCategoryClick = (categoryId) => {
    // Navigate to products page with category ID as state
    navigate("/product", { state: { categoryId } });
  };
  // Fetch categories once
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get(`/categories/`);
        if (res.data && res.data.data) {
          setCategories(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  // Duplicate categories for infinite loop effect
  const repeatedCategories = [...categories, ...categories, ...categories];

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1
          className="text-center"
          style={{ color: "#198754", fontWeight: 700 }}
        >
          About Us
        </h1>
        <hr />
      <h1 className="text-center about-title">
          VALLALAR NATURALS
        </h1>
        <p className="text-center about-subtitle">
          From Village Kannama
        </p>

        {/* Intro Section */}
        <section className="about-section">
          <p className="about-text">
            Vallalar Naturals from Village Kannama was not created as a business
            idea — it was born from real life, real struggles, and a deep love
            for family and village roots.
          </p>

          <p className="about-text">
            Growing up close to farmers, we witnessed the patience, honesty,
            and care with which they nurture the land and grow pure ingredients
            with their bare hands.
          </p>

          <blockquote className="about-quote">
            “Growing up as a farmer’s child taught me patience, care, and respect for nature.”
          </blockquote>
        </section>

        {/* Story Section */}
        <section className="about-section">
          <p className="about-text">
            Despite growing pure ingredients, many farmer families suffer from
            skin problems caused by harsh, chemical-filled products available
            in the market.
          </p>

          <p className="about-text">
            Our journey became deeply personal when our parents and farm
            workers began facing persistent skin issues — dryness, irritation,
            and sensitivity that refused to heal. Products that promised quick
            results only made things worse.
          </p>

          <p className="about-text">
            Watching our parents and villagers struggle pushed us to search
            for safer, gentler solutions — the kind our elders once trusted.
          </p>
        </section>

        {/* Craft Section */}
        <section className="about-section">
          <p className="about-text">
            We turned back to village wisdom, traditional remedies, and natural
            ingredients that had protected generations before us.
          </p>

          <p className="about-text">
            With guidance from farmers and elders, we began handcrafting
            products using pure oils, herbs, and plant-based ingredients —
            prepared traditionally, with patience and care.
          </p>

          <p className="about-text">
            Slowly, our parents’ skin began to heal — not overnight, but
            naturally. That healing became our belief.
          </p>
        </section>

        {/* Values Section */}
        <section className="about-section highlight-box">
          <p className="about-text">
            At Vallalar Naturals, we do not chase trends or shortcuts.
          </p>

          <ul className="about-list">
            <li>No harmful chemicals</li>
            <li>No parabens or sulphates</li>
            <li>No artificial colours</li>
            <li>No synthetic fragrances</li>
          </ul>

          <p className="about-text">
            Every product is made in small batches, maintaining purity,
            hygiene, and authenticity.
          </p>
        </section>

        {/* Mission */}
        <section className="about-section mission-box">
          <h2 className="section-title">Our Mission</h2>
          <p className="about-text text-center">
            To protect skin gently, support village livelihoods, and bring
            back trust between nature and wellness.
          </p>
          <p className="about-text text-center">
            We believe true healing comes from nature, and every product we
            create carries that promise.
          </p>
        </section>

        <h2
          className="text-center py-4"
          style={{ color: "#198754", fontWeight: 600 }}
        >
          Our Categories
        </h2>

        {/* Continuous marquee-like scroll */}
        <div className="marquee-wrapper">
          <div className="marquee">
            {repeatedCategories.map((cat, index) => (
              <div
                key={index}
                className="product-card"
                onClick={() => handleCategoryClick(cat.id)}
                style={{ cursor: "pointer" }}
              >

                <div className="img-wrapper">
                  <img
                    src={
                      cat.category_image
                        ? `${cat.category_image}`
                        : "https://via.placeholder.com/300x200?text=No+Image"
                    }
                    alt={cat.category_name}
                  />
                </div>
                <div className="product-content">
                  <h5 className="product-title">{cat.category_name}</h5>
                  <p className="product-desc">
                    {cat.description || "No description"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
/* ---------- Global Typography ---------- */
h1, h2, h5 {
  font-family: "Poppins", "Segoe UI", sans-serif;
  letter-spacing: 0.3px;
}

/* ---------- Brand Heading ---------- */
.about-title {
  font-size: 2.4rem;
  font-weight: 700;
  color: #1b5e20;
  margin-bottom: 0.25rem;
}

.about-subtitle {
  font-size: 1rem;
  color: #5f7d66;
  letter-spacing: 1px;
  margin-bottom: 2rem;
}

/* ---------- About Sections ---------- */
.about-section {
  max-width: 820px;
  margin: 0 auto 2.5rem;
  line-height: 1.8;
}

.about-text {
  font-size: 1rem;
  color: #2f3e34;
  margin-bottom: 1.2rem;
}

.about-quote {
  margin: 1.8rem auto;
  padding: 1.2rem 1.5rem;
  background: #f3fbf6;
  border-left: 4px solid #198754;
  font-style: italic;
  color: #2e6b45;
}

/* ---------- Values Box ---------- */
.highlight-box {
  background: linear-gradient(135deg, #f1fbf4, #ffffff);
  border-radius: 14px;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.04);
}

.about-list {
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
}

.about-list li {
  font-size: 0.95rem;
  padding: 0.4rem 0;
  color: #2f3e34;
  padding-left: 22px;
  position: relative;
}

.about-list li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #198754;
  font-weight: 600;
}

/* ---------- Mission ---------- */
.mission-box {
  background: #198754;
  color: #ffffff;
  border-radius: 16px;
  padding: 2.5rem 2rem;
}

.mission-box .section-title {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 1rem;
}

.mission-box .about-text {
  color: #e8f5ec;
}

/* ---------- Marquee Wrapper ---------- */
.marquee-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding: 10px 0;
  mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
  -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
}

/* ---------- Marquee Animation (UNCHANGED) ---------- */
.marquee {
  display: flex;
  gap: 20px;
  animation: scrollLeft 10s linear infinite;
  will-change: transform;
}

@keyframes scrollLeft {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* ---------- Product Card ---------- */
.product-card {
  background: #ffffff;
  border-radius: 16px;
  width: 240px;
  height: 310px;
  flex-shrink: 0;
  border: 1px solid rgba(25, 135, 84, 0.15);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 32px rgba(25, 135, 84, 0.22);
}

/* ---------- Image ---------- */
.img-wrapper {
  background: linear-gradient(135deg, #edf8f1, #ffffff);
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-wrapper img {
  width: 75%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.35s ease;
}

.product-card:hover img {
  transform: scale(1.1);
}

/* ---------- Content ---------- */
.product-content {
  padding: 14px 12px;
  text-align: center;
}

.product-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1b5e20;
  margin-bottom: 6px;
}

.product-desc {
  font-size: 0.85rem;
  color: #4a4a4a;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ---------- Pause on Hover ---------- */
.marquee-wrapper:hover .marquee {
  animation-play-state: paused;
}

/* ---------- Responsive ---------- */
@media (max-width: 768px) {
  .product-card {
    width: 200px;
    height: 270px;
  }

  .img-wrapper {
    height: 120px;
  }

  .about-title {
    font-size: 2rem;
  }
}

      `}</style>
    </>
  );
};

export default AboutPage;
